/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ViewProject.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomTabsV2 from "../common/tabs/CustomTabsV2";

function ViewProject({ tabsData, expanded, setExpanded }) {
  const handleAccordionToggle = () => {
    setExpanded(!expanded); // 👈 toggle state from parent
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Accordion
        expanded={expanded}
        sx={{
          boxShadow: 3,
          borderRadius: 0,
          backgroundColor: "#f9f9f9",
          "&:before": { display: "none" },
        }}
        onChange={handleAccordionToggle}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          sx={{
            backgroundColor: "black",
            color: "white",
            borderRadius: 0,
            minHeight: "48px !important",
            "& .MuiAccordionSummary-content": { margin: "8px 0" },
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Project Configuration
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ backgroundColor: "white", p: 2 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              textAlign: "start",
              mb: 2,
            }}
          >
            Project Configuration
          </Typography>

          <Box>
            <CustomTabsV2 tabs={tabsData} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}


ViewProject.propTypes = {
  tabsData: PropTypes.array,
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func
};

export default ViewProject;
